import { PlusOutlined } from "@ant-design/icons";
import { message, Input, Select, Tabs } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  ModalItem,
  FormItem,
  SelectItem,
  cuentaMask,
  InputItem,
  ButtonItem,
  ErrorItem,
} from "../../../../Components/Items";
import AgregarCuentaContable from "../../CuentasContables/AgregarCuentaContable/AgregarCuentaContable";

const { Option } = Select;
const { TabPane } = Tabs;

class AgregarCajaEfectivo extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    objetoBancosSat: null,
    todasBancosSat: null,
    objetoCuentaContable: null,
    todasCuentaContable: null,
    objetoMonedas: null,
    todasMonedas: null,
  };
  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible)
      this.consultarTodo();
  }
  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "cuentascontables/selectCuentasContablesFinales",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasCuentaContable: res.data });
          this.setState({
            objetoCuentaContable: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {cuentaMask(
                    value.nivel1 +
                    value.nivel2 +
                    value.nivel3 +
                    value.nivel4 +
                    value.nivel5
                  ) +
                    " - " +
                    value.descripcion}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post(
        "bancosSat/selectBancosSat",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasBancosSat: res.data });
          this.setState({
            objetoBancosSat: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.clave + " - " + value.nombreCorto}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post("monedas/selectMonedas", null, {
        headers: this.props.headersToken,
      })
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasMonedas: res.data });
          this.setState({
            objetoMonedas: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + " - " + value.abreviacion}
                </Option>
              );
            }),
          });
        }
      });
    this.setState({ loading: false });
  }
  cerrarAgregarCajaEfectivo(codigo) {
    this.props.cerrarAgregarCajaEfectivo(codigo);
  }
  onFinishFailed(e) {
    ErrorItem(e);
  }
  onFinish(values) {
    this.setState({ loading: true });
    axios
      .post(
        "cajaefectivo/agregarCaja",
        { ...values, empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Se agrego un banco");
          this.formRef.current.resetFields();
          this.cerrarAgregarCajaEfectivo(res.data.codigo);
        } else {
          message.error("Sucedio un error y no se guardo");
        }
      });
  }
  abrirAgregarCuentaContable() {
    this.setState({ modalAgregarCuentaContable: true });
  }
  cerrarAgregarCuentaContable(codigo) {
    this.setState({ modalAgregarCuentaContable: false });
    this.consultarTodo();
  }
  render() {
    return (
      <>
        <ModalItem
          title="Agregar Caja"
          visible={this.props.visible}
          spinning={this.state.loading}
          onCancel={this.cerrarAgregarCajaEfectivo.bind(this)}
        >
          <Form
            ref={this.formRef}
            name="agregarCaja"
            layout
            bottom={
              <ButtonItem
                type="primary"
                htmlType="submit"
                style={{ display: "block", margin: "0 0 0 auto" }}
              >
                Agregar
              </ButtonItem>
            }
            onFinish={this.onFinish.bind(this)}
            onFinishFailed={this.onFinishFailed}
          >
            <Tabs defaultActiveKey="1">
              <TabPane tab="Información General" key="1">
                <FormItem name="nombre" label="Nombre" required margin pattern>
                  <InputItem placeholder="Nombre" />
                </FormItem>
                <FormItem name="banco" label="Banco" margin pattern>
                  <InputItem placeholder="Banco" />
                </FormItem>
                <FormItem label="Moneda" name="monedaId" required margin>
                  <SelectItem placeholder="Moneda">
                    {this.state.objetoMonedas}
                  </SelectItem>
                </FormItem>
                <FormItem label="Banco SAT" name="bancoSatId" margin>
                  <SelectItem placeholder="Banco SAT">
                    {this.state.objetoBancosSat}
                  </SelectItem>
                </FormItem>
                <FormItem
                  label="Cuenta Clabe"
                  name="cuentaClabe"
                  number
                  max={18}
                  min={18}
                  margin
                >
                  <InputItem placeholder="Cuenta Clabe" />
                </FormItem>
                <FormItem label="Cuenta Contable" margin>
                  <Input.Group compact>
                    <FormItem name="cuentaContableId" required noStyle>
                      <SelectItem placeholder="Cuenta Contable" width="80%">
                        {this.state.objetoCuentaContable}
                      </SelectItem>
                    </FormItem>
                    <ButtonItem
                      icon={<PlusOutlined />}
                      style={{ width: "20%" }}
                      onClick={this.abrirAgregarCuentaContable.bind(this)}
                    />
                  </Input.Group>
                </FormItem>
                <FormItem
                  name="observaciones"
                  label="Observaciones"
                  margin
                  pattern
                >
                  <InputItem placeholder="Observaciones" />
                </FormItem>
              </TabPane>
              <TabPane tab="Avanzado" key="2">
                <FormItem
                  label="Cta Beneficiario"
                  name="ctaBeneficiario"
                  number
                  max={50}
                  min={10}
                  margin
                  labelCol={{ span: 10 }}
                  wrapperCol={{ span: 14 }}
                  tooltip={{ title: "Se puede registrar el número de cuenta en donde se recibió el pago." }}
                >
                  <InputItem placeholder="Cuenta Beneficiario" />
                </FormItem>
                <FormItem
                  label="Rfc Beneficiaria"
                  name="rfcEmisorCtaBen"
                  rfc
                  margin
                  labelCol={{ span: 10 }}
                  wrapperCol={{ span: 14 }}
                  tooltip={{ title: "Se puede registrar la clave en el RFC de la entidad operadora de la cuenta destino, es decir, la operadora, el banco, la institución financiera, emisor de monedero electrónico, etc." }}
                >
                  <InputItem placeholder="Rfc Emisor Cuenta Beneficiaria" />
                </FormItem>
              </TabPane>
            </Tabs>
          </Form>
        </ModalItem>
        <AgregarCuentaContable
          visible={this.state.modalAgregarCuentaContable}
          cerrarAgregarCuentaContable={this.cerrarAgregarCuentaContable.bind(
            this
          )}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(AgregarCajaEfectivo);
